import React, { Component } from 'react';
import { Container, TabContent, TabPane, Nav, NavItem, NavLink, Row, Col } from 'reactstrap';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';

class Histories extends Component {

	constructor(props) {
		super(props);

		this.state = {
			activeTab: '2'
		};
	}

	toggle = (tab) => {
		if (this.state.activeTab !== tab) {
			this.setState({
				activeTab: tab
			});
		}
	}

	generateHistoriesPucharseMedia = (historiesPucharseMedia) => {
		return [...historiesPucharseMedia].map((item, index) => {
			return (
				<tr key={index}>
					<td className="col-xs-1">{parseInt(index, 10) + 1}</td>
					<td className="col-xs-7"><Link to={"/media/watch/" + item.media.id} >{item.media.name}</Link></td>
					<td className="col-xs-1">{item.media.scoin}</td>
					<td className="col-xs-3">{new Date(item.created_date).toLocaleString()}</td>
				</tr>
			)
		})
	}

	generateHistoriesPucharseDay = (historiesPucharseDay) => {
		return [...historiesPucharseDay].map((item, index) => {
			return (
				<tr key={index}>
					<td className="col-xs-1">{parseInt(index, 10) + 1}</td>
					<td className="col-xs-7">{item.package_purchase_day.scoin}</td>
					<td className="col-xs-1">{item.package_purchase_day.day}</td>
					<td className="col-xs-3">{new Date(item.created_date).toLocaleString()}</td>
				</tr>
			)
		})
	}

	generateHistoriesPackages = (historyPackageDetail) => {
		return [...historyPackageDetail].map((item, index) => {
			return (
				<tr key={index}>
					<td className="col-xs-1">{parseInt(index, 10) + 1}</td>
					<td className="col-xs-6"><Link to={"/package-detail/" + item.package.id} >{item.package.title}</Link></td>
					<td className="col-xs-1">{item.package_detail.scoin}</td>
					<td className="col-xs-1">{item.package_detail.day}</td>
					<td className="col-xs-3">{new Date(item.created_date).toLocaleString()}</td>
				</tr>
			)
		})
	}

	render() {
		let { user_info } = this.props;
		if (JSON.stringify(user_info) === '{}') {
			return 'Loadding...';
		}

		let historiesPucharseMedia = user_info.historiesPucharseMedia;
		let historiesPucharseDay = user_info.historiesPucharseDay;
		let historyPackageDetail = user_info.historyPackageDetail;

		return (
			<div className="pt-8">
				<Container>
					<Row>
						<Col>
							<div>
								<Nav tabs>
									<NavItem>
										<NavLink
											className={classnames({ active: this.state.activeTab === '2' })}
											onClick={() => { this.toggle('2'); }}
										>
											Lịch sử mua phim
            						</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											className={classnames({ active: this.state.activeTab === '3' })}
											onClick={() => { this.toggle('3'); }}
										>
											Lịch sử mua ngày
            						</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											className={classnames({ active: this.state.activeTab === '4' })}
											onClick={() => { this.toggle('4'); }}
										>
											Lịch sử mua gói dịch vụ
            						</NavLink>
									</NavItem>
								</Nav>
								<TabContent activeTab={this.state.activeTab}>
									<TabPane tabId="2">
										<div className="panel panel-default mt-20">
											<div className="panel-heading">
												<h4>
													Danh sách phim đã mua
        										</h4>
											</div>
											<table className="table table-fixed">
												<thead>
													<tr>
														<th className="col-xs-1">#</th>
														<th className="col-xs-7">Tên phim</th>
														<th className="col-xs-1">Scoin</th>
														<th className="col-xs-3">Ngày mua</th>
													</tr>
												</thead>
												<tbody>
													{this.generateHistoriesPucharseMedia(historiesPucharseMedia)}
												</tbody>
											</table>
										</div>
									</TabPane>
									<TabPane tabId="3">
										<div className="panel panel-default mt-20">
											<div className="panel-heading">
												<h4>
													Danh sách mua theo ngày
        										</h4>
											</div>
											<table className="table table-fixed">
												<thead>
													<tr>
														<th className="col-xs-1">#</th>
														<th className="col-xs-7">Scoin</th>
														<th className="col-xs-1">Số ngày mua</th>
														<th className="col-xs-3">Ngày mua</th>
													</tr>
												</thead>
												<tbody>
												{this.generateHistoriesPucharseDay(historiesPucharseDay)}
												</tbody>
											</table>
										</div>
									</TabPane>
									<TabPane tabId="4">
										<div className="panel panel-default mt-20">
											<div className="panel-heading">
												<h4>
													Danh sách gói dịch vụ đã mua
        										</h4>
											</div>
											<table className="table table-fixed">
												<thead>
													<tr>
														<th className="col-xs-1">#</th>
														<th className="col-xs-6">Tên gói</th>
														<th className="col-xs-1">Scoin</th>
														<th className="col-xs-1">Số ngày mua</th>
														<th className="col-xs-3">Ngày mua</th>
													</tr>
												</thead>
												<tbody>
												{this.generateHistoriesPackages(historyPackageDetail)}
												</tbody>
											</table>
										</div>
									</TabPane>
								</TabContent>
							</div>
						</Col>
					</Row>
				</Container>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		user_info: state.root.users
	}
}

export default connect(mapStateToProps)(Histories);


// WEBPACK FOOTER //
// ./src/components/Scoin/Histories.js